import { Component, Host, h, Prop, Element } from '@stencil/core';
import { addIntersectionObserver } from '../../utils/utils';

@Component({
  tag: 'large-image-block',
  styleUrl: 'large-image-block.css',
  shadow: true,
})
export class LargeImageBlock {
  /**
   * The title
   */
  @Prop() mainTitle: string;

  /**
   * The description
   */
  @Prop() description: string;

  /**
   * Text Orientation
   */
  @Prop() textOrientation: string;

  /**
   * Buttons Data
   */
  @Prop() buttonsData: string;

  /**
   * Asset Type
   */
  @Prop() assetType: string;

  /**
   * Image alt
   */
  @Prop() imageAlt: string;

  /**
   * Image Url
   */
  @Prop() imageUrl: any;

  /**
   * Video
   */
  @Prop() videoUrl: string;

  /**
   * Background Color
   */
  @Prop() backgroundColor: string;

  /**
   * Text Color
   */
  @Prop() textColor: string;

  /**
   * Padding Top
   */
  @Prop() paddingTop: string;

  /**
   * Padding Bottom
   */
  @Prop() paddingBottom: string;

  /**
   * Background Image Url
   */
  @Prop() backgroundImage: string;

  @Element() el: HTMLElement;

  componentDidLoad() {
    addIntersectionObserver(
      this.el.shadowRoot.querySelector('.large-image-block-container'),
      () => {
        this.el.shadowRoot.querySelector('.large-image-block-container').classList.add('animate');
      },
      ['.overlay1', '.overlay2'],
    );
  }

  render() {
    const buttons = JSON.parse(this.buttonsData);
    //console.log('buttons', buttons);  
    //console.log('data', this.imageUrl);
    return (
      <Host>
        <section class={`large-image-block-section `} style={{ backgroundImage: `url(${this.backgroundImage})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}>
          <div class={`container large-image-block-container ${this.textOrientation} ${this.paddingBottom} ${this.paddingTop}`}>
            {/* <div class={`overlay1`}></div> */}
            <div class={`large-image-block-background ${this.backgroundColor}`}></div>
            <div class={`large-image-block-content`}>
              <div class={`overlay1`}></div>

              {this.mainTitle && <h3 class={`text-ui-gray-1 ${this.textColor} fs-5 font-semibold mb-20px`}>{this.mainTitle}</h3>}
              {this.description && <div class={`text-ui-gray-1 ${this.textColor} fs-1 font-normal`} innerHTML={this.description}></div>}
              {buttons.length > 0 && buttons[0]['cta'] && (
                <div class="flex gap-12px mt-32px mx-auto justify-center">
                  {buttons.map(button => (
                    <button-block buttonsData={button}></button-block>
                  ))}
                </div>
              )}
            </div>
            <div class={`large-image-block-asset-container`}>
              <div class={`overlay2`}></div>

              {this.assetType === 'image' && this.imageUrl && <image-block imageUrl={this.imageUrl} imageAlt={this.imageAlt} imageClass={`w-full h-full`}></image-block>}
              {this.assetType === 'video' && this.videoUrl && <video-block videoUrl={this.videoUrl} videoClass={`aspect-video w-full h-full`}></video-block>}
            </div>
          </div>
        </section>
      </Host>
    );
  }
}
